import * as THREE from "three";
import { gsap } from "gsap";
import Tools from '../utils/Tools';
import LocaleManager from "./LocaleManager";
import AssetsManager from "./AssetsManager";
import config from "config";

class UiManager extends THREE.Object3D {
    constructor() {
        super();

        this._addScoreUI = null;
        this._addScoreUITime = 1;

        this._showPraises = null;
        this._showPraisesTime = 1;

        this._showTryAgainTime = 1.5;

        // Disable the selection of the text field
        function disableselect(e) {
            return false;
        }
        document.onselectstart = disableselect;

        this._setupAddScore();
        this._setupShowPraises();
        this._setupMobileIco();




        // document.getElementById("loading-screen").remove();
        // document.getElementById("game-ui").remove();
        // // document.getElementById("end-screen").remove();
        // // document.getElementById("retry-screen").remove();


    }

    _setupAddScore() {
        // Add score on the ui
        this._addScoreUI = document.createElement("p");
        this._addScoreUI.id = "this._addScoreUI";
        this._addScoreUI.style.position = "absolute";
        this._addScoreUI.style.top = "calc(26%)";
        this._addScoreUI.style.left = "calc(50%)";
        this._addScoreUI.style.zIndex = "99";
        this._addScoreUI.style.fontSize = "50px";
        this._addScoreUI.style.fontWeight = "bolder";
        this._addScoreUI.style.fontFamily = "sans-serif";
        this._addScoreUI.style.transform = "translate(-50%, -50%)";
        this._addScoreUI.style.opacity = "0";
        this._addScoreUI.style.pointerEvents = "none";
        this._addScoreUI.style.color = "gold";

        // document.body.appendChild(this._addScoreUI);
    }

    _setupShowPraises() {
        // Add praises words on the ui
        this._showPraises = document.createElement("div");
        this._showPraises.id = "this._showPraises";
        this._showPraises.style.position = "absolute";
        this._showPraises.style.top = "26%";
        this._showPraises.style.left = "calc(50% + 58px";
        this._showPraises.style.opacity = "0";
        this._showPraises.style.fontFamily = "sans-serif";
        this._showPraises.style.fontSize = "24px";
        this._showPraises.style.fontWeight = "bolder";
        this._showPraises.style.zIndex = "99";
        this._showPraises.style.color = "#00e63d";
        this._showPraises.style.textTransform = "uppercase";

        // document.body.appendChild(this._showPraises);
    }


    _setupMobileIco() {
        // Add praises words on the ui
        this._mobileOrientation = document.createElement("div");
        this._mobileOrientation.id = "mobileOrientation";
        this._mobileOrientation.style.position = "absolute";
        this._mobileOrientation.style.top = "0px";
        this._mobileOrientation.style.left = "0px";
        this._mobileOrientation.style.zIndex = "1000";
        this._mobileOrientation.style.backgroundColor = "#000";
        this._mobileOrientation.style.width = "100%";
        this._mobileOrientation.style.height = "100%";
        this._mobileOrientation.pointerEvents = "auto";
        this._mobileOrientation.style.visibility = "hidden";

        this._ico = document.createElement("img");
        this._ico.src = config.assets + "/imagesPixi/mobile.png";
        this._ico.style.width = "100px";
        this._ico.style.position = "absolute";
        this._ico.style.top = "50%";
        this._ico.style.left = "50%";
        this._ico.style.transform = "translate(-50px, -50px)";
        this._mobileOrientation.appendChild(this._ico);

        document.body.appendChild(this._mobileOrientation);
    }

    addScore(score) {

        if (score >= 40) {
            this._addScoreUI.innerText = "+" + score;

            gsap.fromTo(this._addScoreUI.style, { opacity: "1" }, { delay: .5, opacity: "0", duration: this._addScoreUITime });
            gsap.fromTo(this._addScoreUI.style, { top: "calc(30%)" }, { top: "calc(15%)", duration: this._addScoreUITime });
        }

    }

    showPraises() {
        const praiseWordsArray = [
            LocaleManager.words.wow,
            LocaleManager.words.perfect,
            LocaleManager.words.nice,
            LocaleManager.words.godlike,
        ];

        const praiseWord = praiseWordsArray[Tools.randomNum(0, 3)];

        this._showPraises.innerText = praiseWord;

        // adapte fontSize
        let fontSize = 24;
        let width = this._showPraises.getBoundingClientRect().width;
        this._showPraises.style.fontSize = fontSize + "px";
        while (width > 180) {
            fontSize--;
            this._showPraises.style.fontSize = fontSize + "px";
            width = this._showPraises.getBoundingClientRect().width;
        }

        var timeline = gsap.timeline();
        gsap.fromTo(this._showPraises.style, { opacity: "1" }, { delay: .2, opacity: "0", duration: this._showPraisesTime });
        gsap.fromTo(this._showPraises.style, { top: "calc(30%)" }, { top: "calc(15% - 10px)", duration: this._showPraisesTime });
    }

    showTryAgain() {
        // Add praises words on the ui
        const showTryAgain = document.createElement("p");
        showTryAgain.id = "showTryAgain";
        showTryAgain.innerText = LocaleManager.words.tryagain;
        showTryAgain.style.position = "absolute";
        showTryAgain.style.top = "calc(20%)";
        showTryAgain.style.left = "calc(50%)";
        showTryAgain.style.transform = "translate(-50%, -50%)";
        showTryAgain.style.fontFamily = "sans-serif";
        showTryAgain.style.fontSize = "32px";
        showTryAgain.style.fontWeight = "bolder";
        showTryAgain.style.textAlign = "center";
        showTryAgain.style.zIndex = "99";
        showTryAgain.style.color = "gold";
        showTryAgain.style.textTransform = "uppercase";

        // document.body.appendChild(showTryAgain);

        var timeline = gsap.timeline();
        timeline.to(showTryAgain.style, { opacity: "1", duration: this._showTryAgainTime * 0.6, ease: "power2.out" });
        timeline.to(showTryAgain.style, { opacity: "0", duration: this._showTryAgainTime * 0.4 });

        gsap.delayedCall(this._showTryAgainTime, () => {
            showTryAgain.remove();
        });
    }

    set orientationPop(val) {
        this._mobileOrientation.style.visibility = val ? "visible" : "hidden";
    }
}

export default UiManager;